import React from 'react';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { getNameOrInitials } from '../../utils/utils';
import useProfile from '../../hooks/use-profile';

interface MyProps {
    grUserId: number;
    size?: number;
}

export default function EmptyScreenShare(props: MyProps) {
    const { grUserId, size } = props;
    const { watchedProfile } = useProfile({ suggestedProfile: grUserId })
	return (
        <div className="empty-shot">
            <div className="empty-video screenshare">
                <Icon name={ICONS.SHARE_SCREEN} color={COLORS.WHITE} size={!size ? 76 : size} />
                <div className="name-label">{getNameOrInitials(watchedProfile, true)}</div>
            </div>
        </div>
	);
}
